!function(root, factory) {
    "object" == typeof exports && "object" == typeof module ? module.exports = factory() : "function" == typeof define && define.amd ? define([], factory) : "object" == typeof exports ? exports.ReactShopifyDraggable = factory() : root.ReactShopifyDraggable = factory();
}("undefined" != typeof self ? self : this, function() {
    /******/
    return function(modules) {
        /******/
        /******/
        // The require function
        /******/
        function __webpack_require__(moduleId) {
            /******/
            /******/
            // Check if module is in cache
            /******/
            if (installedModules[moduleId]) /******/
            return installedModules[moduleId].exports;
            /******/
            // Create a new module (and put it into the cache)
            /******/
            var module = installedModules[moduleId] = {
                /******/
                i: moduleId,
                /******/
                l: !1,
                /******/
                exports: {}
            };
            /******/
            /******/
            // Return the exports of the module
            /******/
            /******/
            /******/
            // Execute the module function
            /******/
            /******/
            /******/
            // Flag the module as loaded
            /******/
            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
            module.l = !0, module.exports;
        }
        // webpackBootstrap
        /******/
        // The module cache
        /******/
        var installedModules = {};
        /******/
        /******/
        // Load entry module and return exports
        /******/
        /******/
        /******/
        /******/
        // expose the modules object (__webpack_modules__)
        /******/
        /******/
        /******/
        // expose the module cache
        /******/
        /******/
        /******/
        // define getter function for harmony exports
        /******/
        /******/
        /******/
        // getDefaultExport function for compatibility with non-harmony modules
        /******/
        /******/
        /******/
        // Object.prototype.hasOwnProperty.call
        /******/
        /******/
        /******/
        // __webpack_public_path__
        /******/
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
        __webpack_require__.d = function(exports, name, getter) {
            /******/
            __webpack_require__.o(exports, name) || /******/
            Object.defineProperty(exports, name, {
                /******/
                configurable: !1,
                /******/
                enumerable: !0,
                /******/
                get: getter
            });
        }, __webpack_require__.n = function(module) {
            /******/
            var getter = module && module.__esModule ? /******/
            function() {
                return module.default;
            } : /******/
            function() {
                return module;
            };
            /******/
            /******/
            return __webpack_require__.d(getter, "a", getter), getter;
        }, __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 7);
    }([ /* 0 */
    /***/
    function(module, exports) {
        module.exports = require("lodash");
    }, /* 1 */
    /***/
    function(module, exports) {
        module.exports = require("react");
    }, /* 2 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _possibleConstructorReturn(self, call) {
            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !call || "object" != typeof call && "function" != typeof call ? self : call;
        }
        function _inherits(subClass, superClass) {
            if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                    "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
                Constructor;
            };
        }(), _react = __webpack_require__(1), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(3), _propTypes2 = _interopRequireDefault(_propTypes), _lodash = __webpack_require__(0), _lodash2 = _interopRequireDefault(_lodash), _classnames = __webpack_require__(4), _classnames2 = _interopRequireDefault(_classnames), _draggable = __webpack_require__(8), _ContextWrapper = __webpack_require__(9), _ContextWrapper2 = _interopRequireDefault(_ContextWrapper), _propertiesChanged = __webpack_require__(5), _CSSPropertyOperations = __webpack_require__(6), DraggableContainer = (_draggable.Sensors.Sensor, 
        function(_Component) {
            /* eslint-disable-line react/sort-comp */
            function DraggableContainer(props) {
                _classCallCheck(this, DraggableContainer);
                var _this = _possibleConstructorReturn(this, (DraggableContainer.__proto__ || Object.getPrototypeOf(DraggableContainer)).call(this, props));
                /* eslint-enable flowtype/no-weak-types */
                /* eslint-disable flowtype/no-weak-types */
                // (this: any).unregisterEvents = this.unregisterEvents.bind(this);
                return _this.contextWrapper = new _ContextWrapper2.default(props), _this.registerEvents = _this.registerEvents.bind(_this), 
                _this.instantiateDraggableInstance = _this.instantiateDraggableInstance.bind(_this), 
                _this;
            }
            return _inherits(DraggableContainer, _Component), _createClass(DraggableContainer, [ {
                key: "registerEvents",
                value: function(props) {
                    var _this2 = this;
                    /* eslint-disable-next-line flowtype/no-weak-types */
                    _lodash2.default.forOwn(props, function(propValue, propName) {
                        if (_lodash2.default.startsWith(propName, "on") && _lodash2.default.isFunction(props[propName])) {
                            var words = _lodash2.default.words(propName).slice(1), eventName = _lodash2.default.toLower(_lodash2.default.join(words, ":"));
                            _this2.draggableInstance && _this2.draggableInstance.on(eventName, propValue);
                        }
                    });
                }
            }, {
                key: "getChildContext",
                value: function() {
                    return {
                        contextWrapper: this.contextWrapper
                    };
                }
            }, {
                key: "instantiateDraggableInstance",
                value: function(props) {
                    var draggable = props.draggable, handle = props.handle, droppable = props.droppable, classes = props.classes, delay = props.delay, sensors = props.sensors, plugins = props.plugins, appendTo = props.appendTo, mirror = props.mirror, collidable = props.collidable, swapAnimation = props.swapAnimation, draggableType = props.type;
                    // IMPORTANT NEED TO DESTROY PREVIOUS INSTANCE
                    this.draggableInstance && this.draggableInstance.destroy();
                    var options = {};
                    if (options.draggable = "." + draggable, options.handle = handle ? "." + handle : null, 
                    options.mirror = mirror, options.swapAnimation = swapAnimation, droppable && (options.droppable = "." + droppable), 
                    collidable && (options.collidable = "." + collidable), classes && (options.classes = classes), 
                    appendTo && (options.appendTo = appendTo), options = _lodash2.default.assign({}, options, {
                        delay: delay,
                        sensors: sensors,
                        plugins: plugins
                    }), this.ownInstance) switch (draggableType) {
                      case "droppable":
                        this.draggableInstance = new _draggable.Droppable(this.ownInstance, options);
                        break;

                      case "swappable":
                        this.draggableInstance = new _draggable.Swappable(this.ownInstance, options);
                        break;

                      case "sortable":
                        this.draggableInstance = new _draggable.Sortable(this.ownInstance, options);
                        break;

                      case "draggable":
                      default:
                        this.draggableInstance = new _draggable.Draggable(this.ownInstance, options);
                    }
                }
            }, {
                key: "componentDidMount",
                value: function() {
                    // console.warn('componentDidMount');
                    var _props = this.props, dragRef = _props.dragRef, eleRef = _props.eleRef;
                    // creates the Draggable instance and register events
                    this.instantiateDraggableInstance(this.props), this.registerEvents(this.props), 
                    // call the refs
                    dragRef && dragRef(this.draggableInstance), eleRef && eleRef(this.ownInstance);
                }
            }, {
                key: "componentWillReceiveProps",
                value: function(nextProps) {
                    // decide if we want to update the context
                    (0, _propertiesChanged.propertiesChanged)(this.props, nextProps, [ "draggable", "handle", "droppable" ]) && this.contextWrapper.update(nextProps), 
                    // decide f we want to reinstantiate the draggable instance
                    // compare all the options
                    (0, _propertiesChanged.propertiesChanged)(this.props, nextProps, [ "draggable", "handle", "droppable", "classes", "delay", "sensors", "plugins", "appendTo", "mirror", "collidable", "swapAnimation", "type" ]) && (this.instantiateDraggableInstance(nextProps), 
                    this.registerEvents(nextProps)), // handle id, className without rerendering
                    _lodash2.default.isEqual(this.props.id, nextProps.id) || this.ownInstance && (this.ownInstance.id = nextProps.id || ""), 
                    _lodash2.default.isEqual(this.props.className, nextProps.className) || this.ownInstance && (// $FlowFixMe
                    this.ownInstance.className = (0, _classnames2.default)(nextProps.className)), // setting style properties
                    _lodash2.default.isEqual(this.props.style, nextProps.style) || this.ownInstance && (this.ownInstance.removeAttribute("style"), 
                    (0, _CSSPropertyOperations.setValueForStyles)(this.ownInstance, nextProps.style));
                }
            }, {
                key: "shouldComponentUpdate",
                value: function(nextProps) {
                    // only rerender if as is different or children
                    return !!(0, _propertiesChanged.propertiesChanged)(this.props, nextProps, [ "as", "children" ]);
                }
            }, {
                key: "componentWillUnmount",
                value: function() {
                    this.draggableInstance && this.draggableInstance.destroy();
                }
            }, {
                key: "render",
                value: function() {
                    var _this3 = this, _props2 = this.props, ElementType = _props2.as, id = _props2.id, className = _props2.className, children = _props2.children, style = _props2.style;
                    return _react2.default.createElement(ElementType, {
                        id: id,
                        className: (0, _classnames2.default)(className),
                        style: style,
                        ref: function(element) {
                            _this3.ownInstance = element;
                        }
                    }, children);
                }
            } ]), DraggableContainer;
        }(_react.Component));
        DraggableContainer.defaultProps = {
            as: "div",
            draggable: "draggable-source",
            handle: null,
            type: "draggable",
            sensors: [],
            plugins: [],
            delay: 100,
            mirror: {
                xAxis: !0,
                yAxis: !0,
                constrainDimensions: !1
            },
            swapAnimation: {
                duration: 150,
                easingFunction: "ease-in-out"
            }
        }, DraggableContainer.childContextTypes = {
            contextWrapper: _propTypes2.default.object
        }, exports.default = DraggableContainer;
    }, /* 3 */
    /***/
    function(module, exports) {
        module.exports = require("prop-types");
    }, /* 4 */
    /***/
    function(module, exports) {
        module.exports = require("classnames");
    }, /* 5 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function propertiesChanged(props, nextProps, properties) {
            var hasDifference = !1;
            return _lodash2.default.forEach(properties, function(property) {
                return _lodash2.default.isEqual(_lodash2.default.get(props, property, null), _lodash2.default.get(nextProps, property, null)) || (hasDifference = !0), 
                !0;
            }), hasDifference;
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.propertiesChanged = propertiesChanged;
        var _lodash = __webpack_require__(0), _lodash2 = function(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }(_lodash);
    }, /* 6 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        // import warnValidStyle from './warnValidStyle';
        /**
 * Operations for dealing with CSS properties.
 */
        /**
     * This creates a string that is expected to be equivalent to the style
     * attribute generated by server-side rendering. It by-passes warnings and
     * security checks so it's not safe to use this value for anything other than
     * comparison. It is only used in DEV for SSR validation.
     */
        // export function createDangerousStringForStyles(styles) {
        //   if (__DEV__) {
        //     let serialized = '';
        //     let delimiter = '';
        //     for (const styleName in styles) {
        //       if (!styles.hasOwnProperty(styleName)) {
        //         continue;
        //       }
        //       const styleValue = styles[styleName];
        //       if (styleValue != null) {
        //         const isCustomProperty = styleName.indexOf('--') === 0;
        //         serialized += delimiter + hyphenateStyleName(styleName) + ':';
        //         serialized += dangerousStyleValue(
        //           styleName,
        //           styleValue,
        //           isCustomProperty
        //         );
        //
        //         delimiter = ';';
        //       }
        //     }
        //     return serialized || null;
        //   }
        // }
        /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */
        /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
        /* eslint-disable */
        function setValueForStyles(node, styles) {
            var style = node.style;
            for (var styleName in styles) if (styles.hasOwnProperty(styleName)) {
                var isCustomProperty = 0 === styleName.indexOf("--"), styleValue = (0, _dangerousStyleValue2.default)(styleName, styles[styleName], isCustomProperty);
                "float" === styleName && (styleName = "cssFloat"), isCustomProperty ? style.setProperty(styleName, styleValue) : style[styleName] = styleValue;
            }
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.setValueForStyles = setValueForStyles;
        var _dangerousStyleValue = __webpack_require__(10), _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue), _hyphenateStyleName = __webpack_require__(12);
        _interopRequireDefault(_hyphenateStyleName);
    }, /* 7 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.DroppableZone = exports.DraggableHandle = exports.DraggableContainer = exports.DraggableItem = void 0;
        var _DraggableContainer = __webpack_require__(2), _DraggableContainer2 = _interopRequireDefault(_DraggableContainer), _getDraggableComponent = __webpack_require__(14), _getDraggableComponent2 = _interopRequireDefault(_getDraggableComponent), DraggableItem = (0, 
        _getDraggableComponent2.default)("item"), DroppableZone = (0, _getDraggableComponent2.default)("zone"), DraggableHandle = (0, 
        _getDraggableComponent2.default)("handle");
        exports.DraggableItem = DraggableItem, exports.DraggableContainer = _DraggableContainer2.default, 
        exports.DraggableHandle = DraggableHandle, exports.DroppableZone = DroppableZone;
    }, /* 8 */
    /***/
    function(module, exports) {
        module.exports = require("@shopify/draggable");
    }, /* 9 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                    "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
                Constructor;
            };
        }(), _lodash = __webpack_require__(0), _lodash2 = function(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }(_lodash);
        __webpack_require__(2);
        var ContextWrapper = function() {
            function ContextWrapper(props) {
                _classCallCheck(this, ContextWrapper), this.draggable = props.draggable, this.handle = props.handle, 
                this.droppable = props.droppable, this.subscriptions = [];
            }
            return _createClass(ContextWrapper, [ {
                key: "update",
                value: function(props) {
                    this.draggable = props.draggable, this.handle = props.handle, this.droppable = props.droppable, 
                    _lodash2.default.forEach(this.subscriptions, function(f) {
                        return f();
                    });
                }
            }, {
                key: "subscribe",
                value: function(f) {
                    this.subscriptions.push(f);
                }
            } ]), ContextWrapper;
        }();
        exports.default = ContextWrapper;
    }, /* 10 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        /**
                                              * Convert a value into the proper css writable value. The style name `name`
                                              * should be logical (no hyphens), as specified
                                              * in `CSSProperty.isUnitlessNumber`.
                                              *
                                              * @param {string} name CSS property name such as `topMargin`.
                                              * @param {*} value CSS property value such as `10px`.
                                              * @return {string} Normalized style value with dimensions applied.
                                              */
        function dangerousStyleValue(name, value, isCustomProperty) {
            return null == value || "boolean" == typeof value || "" === value ? "" : isCustomProperty || "number" != typeof value || 0 === value || _CSSProperty.isUnitlessNumber.hasOwnProperty(name) && _CSSProperty.isUnitlessNumber[name] ? ("" + value).trim() : value + "px";
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _CSSProperty = __webpack_require__(11);
        /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
        /* eslint-disable */
        exports.default = dangerousStyleValue;
    }, /* 11 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        /**
                        * @param {string} prefix vendor-specific prefix, eg: Webkit
                        * @param {string} key style name, eg: transitionDuration
                        * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
                        * WebkitTransitionDuration
                        */
        function prefixKey(prefix, key) {
            return prefix + key.charAt(0).toUpperCase() + key.substring(1);
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        /**
                                                                             * Copyright (c) 2013-present, Facebook, Inc.
                                                                             *
                                                                             * This source code is licensed under the MIT license found in the
                                                                             * LICENSE file in the root directory of this source tree.
                                                                             */
        /**
                                                                                 * CSS properties which accept numbers but are not in units of "px".
                                                                                 */
        /* eslint-disable */
        var isUnitlessNumber = exports.isUnitlessNumber = {
            animationIterationCount: !0,
            borderImageOutset: !0,
            borderImageSlice: !0,
            borderImageWidth: !0,
            boxFlex: !0,
            boxFlexGroup: !0,
            boxOrdinalGroup: !0,
            columnCount: !0,
            columns: !0,
            flex: !0,
            flexGrow: !0,
            flexPositive: !0,
            flexShrink: !0,
            flexNegative: !0,
            flexOrder: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowSpan: !0,
            gridRowStart: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnSpan: !0,
            gridColumnStart: !0,
            fontWeight: !0,
            lineClamp: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            tabSize: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
            // SVG-related properties
            fillOpacity: !0,
            floodOpacity: !0,
            stopOpacity: !0,
            strokeDasharray: !0,
            strokeDashoffset: !0,
            strokeMiterlimit: !0,
            strokeOpacity: !0,
            strokeWidth: !0
        }, prefixes = [ "Webkit", "ms", "Moz", "O" ];
        // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
        // infinite loop, because it iterates over the newly added props too.
        Object.keys(isUnitlessNumber).forEach(function(prop) {
            prefixes.forEach(function(prefix) {
                isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
            });
        });
    }, /* 12 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        /**
                         * Hyphenates a camelcased CSS property name, for example:
                         *
                         *   > hyphenateStyleName('backgroundColor')
                         *   < "background-color"
                         *   > hyphenateStyleName('MozTransition')
                         *   < "-moz-transition"
                         *   > hyphenateStyleName('msTransition')
                         *   < "-ms-transition"
                         *
                         * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
                         * is converted to `-ms-`.
                         *
                         * @param {string} string
                         * @return {string}
                         */
        /**
                             * Copyright (c) 2013-present, Facebook, Inc.
                             *
                             * This source code is licensed under the MIT license found in the
                             * LICENSE file in the root directory of this source tree.
                             *
                             * @providesModule hyphenateStyleName
                             * @typechecks
                             */
        // 'use strict';
        /* eslint-disable */
        // const hyphenate = require('hyphenate');
        function hyphenateStyleName(string) {
            return (0, _hyphenateStyleName2.default)(string).replace(msPattern, "-ms-");
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _hyphenateStyleName = __webpack_require__(13), _hyphenateStyleName2 = function(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }(_hyphenateStyleName), msPattern = /^ms-/;
        exports.default = hyphenateStyleName;
    }, /* 13 */
    /***/
    function(module, exports) {
        module.exports = require("hyphenate-style-name");
    }, /* 14 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _possibleConstructorReturn(self, call) {
            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !call || "object" != typeof call && "function" != typeof call ? self : call;
        }
        function _inherits(subClass, superClass) {
            if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
        }
        // a factory which wraps a component
        function getDraggableComponent(type) {
            return function(_Component) {
                function _class() {
                    return _classCallCheck(this, _class), _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
                }
                return _inherits(_class, _Component), _createClass(_class, [ {
                    key: "render",
                    value: function() {
                        return _react2.default.createElement(_DraggableGenericItem2.default, _extends({}, this.props, {
                            type: type
                        }));
                    }
                } ]), _class;
            }(_react.Component);
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _extends = Object.assign || function(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
            }
            return target;
        }, _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                    "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
                Constructor;
            };
        }();
        exports.default = getDraggableComponent;
        var _react = __webpack_require__(1), _react2 = _interopRequireDefault(_react), _DraggableGenericItem = __webpack_require__(15), _DraggableGenericItem2 = _interopRequireDefault(_DraggableGenericItem);
    }, /* 15 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        function _defineProperty(obj, key, value) {
            return key in obj ? Object.defineProperty(obj, key, {
                value: value,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : obj[key] = value, obj;
        }
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _possibleConstructorReturn(self, call) {
            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !call || "object" != typeof call && "function" != typeof call ? self : call;
        }
        function _inherits(subClass, superClass) {
            if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                    "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
                Constructor;
            };
        }(), _react = __webpack_require__(1), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(4), _classnames2 = _interopRequireDefault(_classnames), _propTypes = __webpack_require__(3), _propTypes2 = _interopRequireDefault(_propTypes), _lodash = __webpack_require__(0), _lodash2 = _interopRequireDefault(_lodash), _propertiesChanged = __webpack_require__(5), _CSSPropertyOperations = __webpack_require__(6), DraggableGenericItem = function(_Component) {
            function DraggableGenericItem() {
                return _classCallCheck(this, DraggableGenericItem), _possibleConstructorReturn(this, (DraggableGenericItem.__proto__ || Object.getPrototypeOf(DraggableGenericItem)).apply(this, arguments));
            }
            return _inherits(DraggableGenericItem, _Component), _createClass(DraggableGenericItem, [ {
                key: "componentDidMount",
                /* eslint-disable-line react/sort-comp */
                value: function() {
                    var _this2 = this;
                    // subscribe to context updates
                    this.context.contextWrapper.subscribe(function() {
                        _this2.ownInstance && _this2.forceUpdate();
                    }), this.props.eleRef && this.props.eleRef(this.ownInstance);
                }
            }, {
                key: "componentWillReceiveProps",
                value: function(nextProps) {
                    // handle id, className without rerendering
                    _lodash2.default.isEqual(this.props.id, nextProps.id) || this.ownInstance && (this.ownInstance.id = nextProps.id || ""), 
                    _lodash2.default.isEqual(this.props.className, nextProps.className) || this.ownInstance && (this.ownInstance.className = nextProps.className || ""), 
                    // setting style properties
                    _lodash2.default.isEqual(this.props.style, nextProps.style) || this.ownInstance && (this.ownInstance.removeAttribute("style"), 
                    (0, _CSSPropertyOperations.setValueForStyles)(this.ownInstance, nextProps.style));
                }
            }, {
                key: "shouldComponentUpdate",
                value: function(nextProps) {
                    // type should never change. its passed from the HOC
                    return !!(0, _propertiesChanged.propertiesChanged)(this.props, nextProps, [ "as", "children", "type" ]);
                }
            }, {
                key: "render",
                value: function() {
                    var _classNames, _this3 = this, _props = this.props, ElementType = _props.as, className = _props.className, id = _props.id, children = _props.children, type = _props.type, style = _props.style;
                    return _react2.default.createElement(ElementType, {
                        id: id,
                        className: (0, _classnames2.default)(className, (_classNames = {}, _defineProperty(_classNames, this.context.contextWrapper.draggable, "item" === type), 
                        _defineProperty(_classNames, this.context.contextWrapper.handle, "handle" === type), 
                        _defineProperty(_classNames, this.context.contextWrapper.droppable, "zone" === type), 
                        _classNames)),
                        style: style,
                        ref: function(element) {
                            _this3.ownInstance = element;
                        }
                    }, children);
                }
            } ]), DraggableGenericItem;
        }(_react.Component);
        DraggableGenericItem.contextTypes = {
            contextWrapper: _propTypes2.default.object
        }, DraggableGenericItem.defaultProps = {
            as: "div",
            type: "item"
        }, exports.default = DraggableGenericItem;
    } ]);
});